import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import { actionAccess } from "constants/actionAccess";
import { ORDER_TYPE, SHIPPING_TYPE } from "constants/order";
import { CheckActionAccess } from "helpers/utils";
import {
  useCancelOrder,
  useCancelOrderReasonList,
  useDetailBus,
  useDetailCustomer,
  useDetailMyOrder,
  useDetailOrderAttachments,
  useDetailOrderHistory,
  useDetailRunnerUser,
  useDetailTransport,
  useDistricts,
  useListShippingUnitAll,
  useOrderStatus,
  useProvinces,
  useResourceType,
  useWards,
} from "hooks";
import {
  useDeleteResource,
  useDownloadMultipleResources,
  useResourceGlobalPreview,
} from "hooks/resource-global/useResourceGlobal";
import OrderDetailChild from "pages/Orders/OrderDetail/OrderDetailChild/OrderDetailChild";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import UpdateRefCodeForm from "../../../Orders/OrderDetail/OrderDetailPage/UpdateRefCodeForm";
import OrderDetailAttachments from "../OrderDetailAttachments/OrderDetailAttachments";
import OrderDetailForm from "../OrderDetailForm/OrderDetailForm";
import OrderDetailHistory from "../OrderDetailHistory/OrderDetailHistory";
import "./OrderDetailPage.scss";
import WarningNote from "pages/Orders/OrderDetail/OrderDetailPage/WarningNote";
import { getLableOrderStatus } from "pages/Orders/utils";

const initRunnerDetailParams = {
  runner_id: "",
};
const initTransportParams = {
  transportId: "",
};
const initBusParams = {
  busId: "",
};
const initCustomerParams = () => {
  return {
    customerId: "",
  };
};

const initLocalitiesParams = () => {
  return {
    countryId: 1,
    type: 1,
    parent_code: "",
  };
};

const MyOrderDetailPage = props => {
  const { t } = useTranslation(["order"]);

  const ref = useRef(null);

  const [userType, setUserType] = useState();
  const [resourceId, setResourceId] = useState(null);
  const [order, setOrder] = useState(null);
  const [runnerParams, setRunnerParams] = useState(initRunnerDetailParams);

  const [openCancelOrderPopup, setOpenCancelOrderPopup] = useState(false);

  const pageParams = useParams();
  const { orderDetailId: orderId = null } = pageParams;
  const [isHCMOrder, setIsHCMOrder] = useState();
  const [shipping, setShipping] = useState();
  const [transportParam, setTransportParam] = useState(initTransportParams);
  const [busParam, setBusParam] = useState(initBusParams);
  const [customerParams, setCustomerParams] = useState(initCustomerParams);
  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);
  const [shouldRenderParentButton, setShouldRenderParentButton] =
    useState(false);
  const [shouldRenderChildrenOrders, setShouldRenderChildrenOrders] =
    useState(false);
  // Detail Order
  const onSuccessDetailOrder = data => {
    // Là đơn chành xe: shipping_type = 3 , trạng thái đơn là: tạo đơn, đang chờ thì được update refCode
    const isAllowUpdateRefCode =
      data?.shipping_type === 3 && (data?.status === 1 || data?.status === 6);
    setIsAllowUpdateRefCode(isAllowUpdateRefCode);
    //
    setOrder(data);
    setOrderRefCode(data.ref_code);
    // setShouldRenderParentButton(String(data?.type) !== "1");
    const isOrderGetGoods =
      Number(data?.type) === ORDER_TYPE.RECEIVE.value &&
      Number(data?.is_receive_bus) === 1;
    setShouldRenderChildrenOrders(
      (data?.childs?.length > 0 || data?.child_codes?.length > 0) ||
        isOrderGetGoods
    );
  };
  const { refetch: detailOrder } = useDetailMyOrder(
    {
      orderId: orderId,
    },
    onSuccessDetailOrder
  );

  // order status list
  const { refetch: fetchOrderStatusList, data: orderStatusList } =
    useOrderStatus({ orderId: orderId });

  // order detail distory
  const {
    refetch: fetch_orderDetailHistory,
    data: history,
    isLoading: isHistoryLoading,
  } = useDetailOrderHistory({
    orderId: orderId,
  });

  // order detail attachments
  const {
    refetch: fetch_orderDetailAttachments,
    data: attachments,
    isLoading: isAttachmentsLoading,
  } = useDetailOrderAttachments({
    orderId: orderId,
  });

  useEffect(() => {
    setResourceId(resourceId);
    onFetchReason();
    detailOrder();
  }, []);

  //get resource type
  const { data: resourceType } = useResourceType();
  // resource global preview
  const {
    data: resourceData,
    isLoading: isLoadingResource,
    refetch: fetchResourceGlobalPreview,
  } = useResourceGlobalPreview({
    resourceId: resourceId,
  });

  // download multiple resources
  const onSuccessDownloadMultipleResources = data => {
    if (!!data) {
      var url = window.URL || window.webkitURL;
      const urlData = url.createObjectURL(
        new Blob([data], { type: "application/zip" })
      );
      const link = document.createElement("a");
      link.href = urlData;
      link.target = "_blank";
      link.setAttribute("download", "Attachments.zip");
      document.body.append(link);
      link.click();
      document.body.removeChild(link);
      url.revokeObjectURL(urlData);
    }
  };
  const onErrorDownloadMultipleResources = error => {};

  const {
    mutate: downloadMultipleResources,
    isLoading: isDownloadingMultipleResources,
  } = useDownloadMultipleResources(
    onSuccessDownloadMultipleResources,
    onErrorDownloadMultipleResources
  );

  // delete resource
  const onDeleteResourceSuccess = data => {
    fetch_orderDetailAttachments();
  };
  const { mutate: deleteResource, isLoading: isDeletingResource } =
    useDeleteResource(onDeleteResourceSuccess, () => {});

  const { data: provinces, refetch: refetchProvinces } =
    useProvinces(provinceParams);
  const { data: districts, refetch: refetchDistricts } =
    useDistricts(districtParams);
  const { data: wards, refetch: refetchWards } = useWards(wardParams);

  // get runner by id
  const { data: runner, refetch: runnerDetail } =
    useDetailRunnerUser(runnerParams);

  useEffect(() => {
    if (runnerParams && runnerParams.run) runnerDetail();
  }, [runnerParams]);

  useEffect(() => {
    //get runner by id
    if (order?.orderDelivery?.runner_id)
      setRunnerParams({ runnerId: order?.orderDelivery?.runner_id, run: true });
  }, [order]);

  // get shipping type all
  const { data: shippingTypeAll, refetch: listShippingTypeAll } =
    useListShippingUnitAll();

  useEffect(() => {
    listShippingTypeAll();
  }, []);

  useEffect(() => {
    setUserType(localStorage.getItem("user_type"));
  }, []);

  useEffect(() => {
    if (resourceId) {
      fetchResourceGlobalPreview();
    }
  }, [resourceId]);

  useEffect(() => {
    if (orderId) {
      fetchOrderStatusList();
      fetch_orderDetailHistory(orderId);
      fetch_orderDetailAttachments(orderId);
    }
  }, [orderId]);

  useEffect(() => {
    setDistrictParams(prev => ({ ...prev, type: 2 }));
    setWardParams(prev => ({ ...prev, type: 3 }));
  }, []);
  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts]);

  useEffect(() => {
    if (wardParams?.type === 3) refetchWards();
  }, [wardParams, refetchWards]);

  const getImagePreview = id => {
    setResourceId(id);
  };
  const dowloadMultipleResources = ids => {
    downloadMultipleResources(ids);
  };

  const onSuccessCancelOrder = () => {
    detailOrder();
    fetch_orderDetailHistory(orderId);
    ref?.current?.clearChildrenList();
  };
  const { mutate: cancelOrder } = useCancelOrder(onSuccessCancelOrder);
  // Fetching reason cancel order list
  const { refetch: onFetchReason, data: reasonListData } =
    useCancelOrderReasonList(1);

  const handleCancelOrder = value => {
    if (value.reasonId) {
      cancelOrder({
        orderId: order.id,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: order.order_code,
      });
      setOpenCancelOrderPopup(false);
    }
  };
  const hasCancel = order?.status === 1 || order?.status === 6;
  const isAllowCancel = CheckActionAccess(
    actionAccess.GLOG_FUNCTION_MY_ORDER_CANCEL
  );

  //shipping detail
  const onSuccessTransportDetail = data => {
    setShipping(data);
  };
  const onSuccessBusDetail = data => {
    setShipping(data);
  };

  const { data: transport, refetch: transportDetail } = useDetailTransport(
    transportParam,
    onSuccessTransportDetail
  );

  const { data: bus, refetch: busDetail } = useDetailBus(
    busParam,
    onSuccessBusDetail
  );

  useEffect(() => {
    const hcmOrder =
      order?.shipping_type === SHIPPING_TYPE.RUNNER ? true : false;
    setIsHCMOrder(hcmOrder);

    // 3 is bus
    if (order?.orderDelivery?.shipping_type === 3)
      setBusParam({ busId: order?.orderDelivery?.bus_id });
    else if (order?.orderDelivery?.shipping_type === 2)
      // 2 is transport
      setTransportParam({ transportId: order?.orderDelivery?.transport_id });

    setCustomerParams(prev => ({
      ...prev,
      customerId: order?.customer_id,
    }));
  }, [order]);

  useEffect(() => {
    if (transportParam?.transportId) transportDetail();
  }, [transportParam]);

  useEffect(() => {
    if (busParam?.busId) busDetail();
  }, [busParam]);

  const { data: customer, refetch: fetch_detailCustomer } =
    useDetailCustomer(customerParams);

  useEffect(() => {
    if (customerParams?.customerId) fetch_detailCustomer();
  }, [customerParams, fetch_detailCustomer]);

  const [isAllowUpdateRefCode, setIsAllowUpdateRefCode] = useState(false);
  const [orderRefCode, setOrderRefCode] = useState("");
  const [modalRefCodeOpen, setModalRefCodeOpen] = useState(false);

  const onSuccessInsertOrderRefCode = data => {
    setOrderRefCode(data.ref_code);
    setModalRefCodeOpen(false);
  };
  useEffect(() => {
    if (!order) return;

    const isThreeLevel =
      order?.is_new_address === "O" ||
      order?.sender_ward_code ||
      order?.reciever_ward_code;

    const recordStatus = isThreeLevel ? "C" : "O";

    setProvinceParams(prev => ({ ...prev, record_status: recordStatus }));
    setDistrictParams(prev => ({ ...prev, record_status: recordStatus }));
    setWardParams(prev => ({ ...prev, record_status: recordStatus }));
  }, [order]);

  return (
    <React.Fragment>
      <div className="page-content OrderDetailPage">
        <Container fluid={true}>
          <div className="d-md-flex justify-content-between">
            <div className="d-md-flex gap-3 align-items-center pb-0 OrderDetailPage__Title">
              <MetaTags>
                <title>{t("detail.title")}</title>
              </MetaTags>
              <BreadcrumbWithLink
                title={
                  <div className="d-flex align-items-center gap-2">
                    {t("detail.title")} {order?.order_code}
                    {order?.order_code && (
                      <Button
                        className="bg-light"
                        color=""
                        onClick={e =>
                          navigator.clipboard.writeText(order?.order_code)
                        }
                      >
                        <i className="far fa-copy fa-md text-secondary" />
                      </Button>
                    )}
                  </div>
                }
              />
              <div className="mt-3 m-md-0 d-flex gap-3">
                <WarningNote orderData={order} />
                {hasCancel && isAllowCancel && !order?.parent_id && (
                  <>
                    <Button
                      color="danger"
                      outline
                      className="border-0"
                      size="xs"
                      onClick={() =>
                        setOpenCancelOrderPopup(!openCancelOrderPopup)
                      }
                    >
                      {t("detail.cancelBtn")}
                    </Button>
                    <ConfirmModal
                      isOpen={openCancelOrderPopup}
                      titleHeader={`
                        ${t("action.cancel.title", {
                          order_code: order?.order_code,
                        })} ?`}
                      titleBody={t("action.cancel.description")}
                      onConfirm={handleCancelOrder}
                      textBtnConfirm={t("button.confirm")}
                      textBtnCancel={t("button.cancel")}
                      toggle={() => setOpenCancelOrderPopup(false)}
                      isReasonDeleteCheckbox={true}
                      reasonList={reasonListData?.items}
                      isHaveNote={true}
                    />
                  </>
                )}
                {order?.parent_id && shouldRenderParentButton && (
                  <Button
                    color="info"
                    // style={{ backgroundColor: "#3C64B1" }}
                    onClick={() => {
                      window.open(`/my-orders/${order?.parent_id}`, "_blank");
                    }}
                  >
                    {t("button.parent_order")}
                  </Button>
                )}
              </div>
            </div>
            <Modal
              isOpen={modalRefCodeOpen}
              autoFocus={true}
              toggle={() => setModalRefCodeOpen(!modalRefCodeOpen)}
            >
              <div className="modal-content">
                <ModalHeader>{t("title.update_ref_code")}</ModalHeader>
                <ModalBody>
                  <UpdateRefCodeForm
                    orderId={order?.id}
                    onSuccess={onSuccessInsertOrderRefCode}
                    refCode={orderRefCode}
                  />
                </ModalBody>
              </div>
            </Modal>
            <div className="mt-3 my-md-auto">
              {t("detail.referCode")}:{" "}
              <span>
                {orderRefCode ? (
                  <span>
                    {orderRefCode}
                    <Button
                      className="bg-light"
                      size="sm"
                      color=""
                      onClick={e => navigator.clipboard.writeText(orderRefCode)}
                      style={{
                        marginLeft: 4,
                      }}
                    >
                      <i className="far fa-copy fa-md text-secondary" />
                    </Button>
                  </span>
                ) : (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    style={{
                      cursor: isAllowUpdateRefCode ? "pointer" : "default",
                    }}
                    className={
                      isAllowUpdateRefCode ? "text-danger" : "text-warning"
                    }
                    onClick={() => {
                      if (!isAllowUpdateRefCode) {
                        return;
                      }
                      setModalRefCodeOpen(true);
                    }}
                  >
                    {t("form.no_information")}
                  </a>
                )}
              </span>
            </div>
            {window.innerWidth <= 767 && order?.status && (
              <div className="mt-2 fs-6">
                Trạng thái:{" "}
                {getLableOrderStatus(orderStatusList, order?.status)}
              </div>
            )}
          </div>
          {order &&
          order.shipping_type === 3 &&
          (order.status === 1 || order.status === 6) ? (
            <div className={"mt-2"}>
              <i className="dripicons-information text-success"> </i>
              <i>
                {t("message.note", {
                  order_code: order.order_code,
                })}
              </i>
            </div>
          ) : (
            <></>
          )}
          {customer && customer.code === "GSNEW" ? (
            <div className={"mt-2"}>
              <i className="dripicons-information text-danger"> </i>
              <i className="text-danger">{t("message.note_create_GSNEW")}</i>
            </div>
          ) : (
            <></>
          )}
          <Card body className="mt-3">
            <OrderDetailForm
              data={order}
              orderStatusList={orderStatusList}
              provinces={provinces}
              districts={districts}
              wards={wards}
              shippingUnitType={shippingTypeAll}
              runner={runner}
              isHCMOrder={isHCMOrder}
              shipping={shipping}
              customer={customer}
            />
          </Card>
          <OrderDetailAttachments
            data={attachments}
            resourceType={resourceType}
            userType={userType}
            resourceData={resourceData}
            isLoading={isAttachmentsLoading}
            isLoadingResource={isLoadingResource}
            isDownloadingMultipleResources={isDownloadingMultipleResources}
            isDeletingResource={isDeletingResource}
            getImagePreview={getImagePreview}
            dowloadMultipleResources={dowloadMultipleResources}
            deleteResource={id => {
              deleteResource(id);
            }}
          />
          <OrderDetailHistory
            data={history}
            status={orderStatusList}
            isLoading={isHistoryLoading}
          />
          {shouldRenderChildrenOrders && (
            <OrderDetailChild
              ref={ref}
              path={"my-orders"}
              parent_id={order?.id}
              parent_code={order?.order_code}
              orderStatusList={orderStatusList}
              refetchDetailOrder={detailOrder}
              isReceiveBus={order?.is_receive_bus}
              parentStatus={order?.status}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MyOrderDetailPage;
